import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9bfdc8b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "information_warp" }
const _hoisted_3 = {
  key: 0,
  class: "content_datastatistic"
}
const _hoisted_4 = { class: "mod_c content_d_count" }
const _hoisted_5 = { class: "mod_c_title" }
const _hoisted_6 = { class: "mod_c_tbody" }
const _hoisted_7 = { class: "information_message" }
const _hoisted_8 = { class: "message_time" }
const _hoisted_9 = { class: "message_minute" }
const _hoisted_10 = { class: "minute_time" }
const _hoisted_11 = { class: "minute_text" }
const _hoisted_12 = { class: "content_information" }
const _hoisted_13 = { class: "mod_c_title" }
const _hoisted_14 = { class: "mod_nav_btn_title" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mod_nav_btn_title" }, "发起直播", -1))
const _hoisted_16 = { class: "mod_c_tbody" }
const _hoisted_17 = { class: "main" }
const _hoisted_18 = { class: "information_repeat" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "information_bigtitle" }, "观看地址：", -1))
const _hoisted_20 = { class: "repeat_input" }
const _hoisted_21 = { class: "repeat_btn" }
const _hoisted_22 = ["href"]
const _hoisted_23 = { class: "information_image" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "information_bigtitle" }, "直播封面：", -1))
const _hoisted_25 = { class: "image_beijing" }
const _hoisted_26 = ["src"]
const _hoisted_27 = { class: "image_qrcode" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "information_bigtitle" }, "扫码观看：", -1))
const _hoisted_29 = ["src"]
const _hoisted_30 = { class: "image_download" }
const _hoisted_31 = { class: "informate_message" }
const _hoisted_32 = { class: "information_time" }
const _hoisted_33 = { class: "time_start" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "starttime" }, "直播模式：", -1))
const _hoisted_35 = { class: "time" }
const _hoisted_36 = { class: "Live_mode" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "starttime" }, "并发人数：", -1))
const _hoisted_38 = { class: "time" }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { key: 1 }
const _hoisted_41 = { class: "Live_mode" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "starttime" }, "报名表单：", -1))
const _hoisted_43 = { class: "time" }
const _hoisted_44 = { class: "Live_mode" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "starttime" }, "起始时间：", -1))
const _hoisted_46 = { class: "time" }
const _hoisted_47 = { class: "informate_url" }
const _hoisted_48 = {
  key: 1,
  class: "content_information"
}
const _hoisted_49 = { class: "mod_c" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mod_c_title" }, "快捷设置", -1))
const _hoisted_51 = { class: "mod_c_tbody" }
const _hoisted_52 = { class: "main" }
const _hoisted_53 = { class: "set_item_wrap" }
const _hoisted_54 = { class: "set_item_action" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Crumb = _resolveComponent("Crumb")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_BeautifyCode = _resolveComponent("BeautifyCode")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_VideoeEmbed = _resolveComponent("VideoeEmbed")!
  const _component_Qualifications = _resolveComponent("Qualifications")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Crumb, null, {
      title: _withCtx(() => [
        _createTextVNode(" 直播总览 ")
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.isShowliveData)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createTextVNode(" 数据统计 "),
                  _createVNode(_component_a_button, {
                    type: "link",
                    class: "home_link_more mod_home_section_btn",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onChangeRoute()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("更多>>")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Pulltime, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "message_txt",
                        key: item.id
                      }, [
                        _createElementVNode("div", _hoisted_8, _toDisplayString(item.name), 1),
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("span", {
                              class: "minute_color",
                              style: _normalizeStyle({ color: item.color })
                            }, _toDisplayString(item.num), 5),
                            _createElementVNode("span", _hoisted_11, _toDisplayString(item.text), 1)
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", {
            class: "mod_c footer_information",
            style: _normalizeStyle({ minHeight: !_ctx.isShowliveData ? 'calc(100vh - 180px)' : '' })
          }, [
            _createElementVNode("div", _hoisted_13, [
              _createTextVNode(" 直播间信息 "),
              _withDirectives(_createVNode(_component_a_button, {
                class: _normalizeClass(["mod_btn_primary actived", { no_remarks: _ctx.liveInfo.filing_status === 1 }]),
                style: {"margin-left":"15px"},
                onClick: _ctx.openShowAttestation
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_svg_icon, { "icon-class": "keep_on_record" })
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.liveInfo.filing_status === 1 ? '未备案' : '已备案'), 1)
                ]),
                _: 1
              }, 8, ["class", "onClick"]), [
                [_vShow, _ctx.liveInfo.filing_status]
              ]),
              _createVNode(_component_router_link, {
                to: { name: 'Console', params: { studioId: _ctx.route?.params.studioId } }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "link",
                    class: "mod_switch_btn mod_home_section_btn content_information_nav"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_svg_icon, { "icon-class": "menu_control" }),
                      _createTextVNode(),
                      _hoisted_15
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("div", _hoisted_20, [
                    _createTextVNode(_toDisplayString(_ctx.liveData.qr_code_url) + " ", 1),
                    _createVNode(_component_a_button, {
                      class: "copy_btn warrant",
                      type: "link",
                      "data-clipboard-text": _ctx.liveData.qr_code_url,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.Copylist('.warrant')))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_svg_icon, { "icon-class": "live_url_copy" })
                      ]),
                      _: 1
                    }, 8, ["data-clipboard-text"])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_a_button, { type: "primary" }, {
                      default: _withCtx(() => [
                        _createElementVNode("a", {
                          href: _ctx.liveData.qr_code_url,
                          target: "_blank"
                        }, "打开", 8, _hoisted_22)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createElementVNode("div", _hoisted_25, [
                    _withDirectives(_createElementVNode("img", {
                      src: _ctx.liveData.image_player_cover_url
                    }, null, 8, _hoisted_26), [
                      [_vShow, _ctx.liveData.image_player_cover_url]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _createElementVNode("div", {
                      class: _normalizeClass(["qrcode", { white: _ctx.liveData.qr_code_pic }]),
                      ref: "qrCodeUrl"
                    }, [
                      _withDirectives(_createElementVNode("img", {
                        src: _ctx.liveData.qr_code_pic
                      }, null, 8, _hoisted_29), [
                        [_vShow, _ctx.liveData.qr_code_pic]
                      ]),
                      _withDirectives(_createElementVNode("div", _hoisted_30, [
                        _createVNode(_component_a_button, {
                          class: "mod_btn_primary actived",
                          onClick: _ctx.showModal
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_svg_icon, {
                              "icon-class": "buling_code",
                              style: {"margin-right":"4px"}
                            }),
                            _createTextVNode("美化")
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_a_button, {
                          class: "mod_btn_primary actived",
                          onClick: _ctx.downs
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_svg_icon, {
                              "icon-class": "dow_code",
                              style: {"margin-right":"4px"}
                            }),
                            _createTextVNode("下载")
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ], 512), [
                        [_vShow, _ctx.liveData.qr_code_pic]
                      ])
                    ], 2)
                  ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _hoisted_34,
                      _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.liveData.mode_title), 1)
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _hoisted_37,
                      _createElementVNode("div", _hoisted_38, [
                        (_ctx.liveData.limit != 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(_ctx.liveData ? _ctx.liveData.limit : 0) + "人", 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_40, "不限"))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _hoisted_42,
                      _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.liveData.registration_form), 1)
                    ]),
                    _createElementVNode("div", _hoisted_44, [
                      _hoisted_45,
                      _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.liveData ? _ctx.liveData.start_at : ''), 1),
                        _createTextVNode(" ~ "),
                        _createElementVNode("span", null, _toDisplayString(_ctx.liveData ? _ctx.liveData.end_at : ''), 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _createVNode(_component_a_button, {
                    class: "btn_link",
                    onClick: _ctx.openEmbed
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("拉流/播放器嵌入")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ])
            ])
          ], 4)
        ]),
        (_ctx.isShowliveData && _ctx.isShowUrl)
          ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, [
                _hoisted_50,
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("div", _hoisted_53, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterAcitionGroup, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "set_item",
                          key: item.router
                        }, [
                          _createElementVNode("h6", null, _toDisplayString(item.title), 1),
                          _createElementVNode("div", _hoisted_54, [
                            _createVNode(_component_a_switch, {
                              checked: item.state,
                              size: "small",
                              onChange: ($event: any) => (_ctx.onChangeQuickSet(item.router, item.state)),
                              checkedValue: 1,
                              unCheckedValue: 0
                            }, null, 8, ["checked", "onChange"]),
                            _createVNode(_component_router_link, {
                              to: { name: item.router, params: { studioId: _ctx.route?.params.studioId } }
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_button, {
                                  type: "link",
                                  size: "large",
                                  class: "set_item_action_icon"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_svg_icon, { "icon-class": "live_quick_set" })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_a_modal, {
        visible: _ctx.showVisible,
        "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showVisible) = $event)),
        centered: "",
        width: "850px",
        title: "美化二维码",
        footer: false
      }, {
        default: _withCtx(() => [
          _createVNode(_component_BeautifyCode)
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_a_modal, {
        visible: _ctx.showEmbed,
        "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showEmbed) = $event)),
        centered: "",
        width: "580px",
        title: "拉流/播放器嵌入",
        onOk: _cache[4] || (_cache[4] = 
        () => {
          _ctx.showEmbed = false;
        }
      )
      }, {
        default: _withCtx(() => [
          (_ctx.showEmbed)
            ? (_openBlock(), _createBlock(_component_VideoeEmbed, { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_a_modal, {
        visible: _ctx.showAttestation,
        "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showAttestation) = $event)),
        centered: "",
        width: "895px",
        title: "资质备案",
        onOk: _ctx.saveQualificat
      }, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_Qualifications, {
            modelValue: _ctx.qualifications,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.qualifications) = $event))
          }, null, 8, ["modelValue"]), [
            [_vShow, _ctx.showAttestation]
          ])
        ]),
        _: 1
      }, 8, ["visible", "onOk"])
    ])
  ], 64))
}